import { render } from "./ServiceSection.vue?vue&type=template&id=bd01c03c&scoped=true"
import script from "./ServiceSection.vue?vue&type=script&lang=js"
export * from "./ServiceSection.vue?vue&type=script&lang=js"

import "./ServiceSection.vue?vue&type=style&index=0&id=bd01c03c&scoped=true&lang=css"

import exportComponent from "/home/brandon/Code/Clients/PhilipComan/specialty-studio-vuetify-theme-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd01c03c"]])

export default __exports__